/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import toast from "react-hot-toast";

export default function Alarmlarim() {
    const [alarmlar,    setAlarmlar]    = useState([]);
    const [yukleniyor,  setYukleniyor]  = useState(true);
    const [duzenleItem, setDuzenleItem] = useState(null); // düzenlenen alarm
    const [filtre,      setFiltre]      = useState("hepsi"); // hepsi | aktif | pasif

    const yukle = async () => {
        setYukleniyor(true);
        try {
            const { data, error } = await supabase
                .from("alerts")
                .select("*")
                .order("created_at", { ascending: false });
            if (error) throw error;
            setAlarmlar(data || []);
        } catch (e) {
            toast.error("Alarmlar yüklenemedi: " + e.message);
        } finally {
            setYukleniyor(false);
        }
    };

    useEffect(() => { yukle(); }, []);

    const durumDegistir = async (id, aktif) => {
        try {
            const { error } = await supabase.from("alerts")
                .update({ aktif, updated_at: new Date().toISOString() })
                .eq("id", id);
            if (error) throw error;
            toast.success(aktif ? "Alarm aktifleştirildi" : "Alarm pasifleştirildi");
            yukle();
        } catch (e) {
            toast.error(e.message);
        }
    };

    const sil = async (id) => {
        if (!window.confirm("Bu alarmı silmek istediğinize emin misiniz?")) return;
        try {
            const { error } = await supabase.from("alerts").delete().eq("id", id);
            if (error) throw error;
            toast.success("Alarm silindi");
            yukle();
        } catch (e) {
            toast.error(e.message);
        }
    };

    const kaydet = async () => {
        if (!duzenleItem?.hedef_fiyat) { toast.error("Hedef fiyat girin"); return; }
        try {
            const fiyat  = parseFloat(duzenleItem.fiyat) || 0;
            const hedef  = parseFloat(duzenleItem.hedef_fiyat);
            const pot    = fiyat > 0 ? parseFloat(((hedef - fiyat) / fiyat * 100).toFixed(2)) : null;
            const { error } = await supabase.from("alerts")
                .update({
                    hedef_fiyat:     hedef,
                    potansiyel:      pot,
                    bildirim_mail:   duzenleItem.bildirim_mail,
                    bildirim_popup:  duzenleItem.bildirim_popup,
                    updated_at:      new Date().toISOString(),
                })
                .eq("id", duzenleItem.id);
            if (error) throw error;
            toast.success("Alarm güncellendi");
            setDuzenleItem(null);
            yukle();
        } catch (e) {
            toast.error(e.message);
        }
    };

    const gosterilen = alarmlar.filter(a =>
        filtre === "hepsi" ? true : filtre === "aktif" ? a.aktif : !a.aktif
    );

    const tarihFormat = (t) => t
        ? new Date(t).toLocaleString("tr-TR", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit" })
        : "—";

    if (yukleniyor) return (
        <div style={{ padding: "2rem", color: "#6b7280" }}>⏳ Yükleniyor...</div>
    );

    return (
        <div style={s.sayfa}>
            <div style={s.header}>
                <div>
                    <h2 style={s.baslik}>⏰ Alarmlarım</h2>
                    <p style={s.altBaslik}>Fiyat alarmlarınızı buradan yönetebilirsiniz</p>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    {["hepsi", "aktif", "pasif"].map(f => (
                        <button key={f} onClick={() => setFiltre(f)}
                            style={{ ...s.filtreBtn, background: filtre === f ? "#1e3a5f" : "white",
                                color: filtre === f ? "white" : "#374151" }}>
                            {f === "hepsi" ? "Hepsi" : f === "aktif" ? "✅ Aktif" : "⏸ Pasif"}
                            <span style={{ marginLeft: "4px", fontSize: "11px", opacity: 0.8 }}>
                                ({alarmlar.filter(a => f === "hepsi" ? true : f === "aktif" ? a.aktif : !a.aktif).length})
                            </span>
                        </button>
                    ))}
                </div>
            </div>

            {gosterilen.length === 0 ? (
                <div style={s.bos}>
                    <div style={{ fontSize: "48px", marginBottom: "1rem" }}>⏰</div>
                    <div style={{ fontWeight: "600", color: "#374151" }}>
                        {filtre === "aktif" ? "Aktif alarm yok" : filtre === "pasif" ? "Pasif alarm yok" : "Henüz alarm eklemediniz"}
                    </div>
                    <div style={{ color: "#9ca3af", fontSize: "13px", marginTop: "4px" }}>
                        Dip Tarama sonuçlarındaki ⏰ butonundan alarm ekleyebilirsiniz
                    </div>
                </div>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <table style={s.tablo}>
                        <thead>
                            <tr style={s.thead}>
                                {["Sembol", "Piyasa", "Para Bir.", "Fiyat", "Hedef", "Potansiyel", "Bildirim", "Oluşturulma", "Tetiklenme", "Durum", "İşlemler"].map(h => (
                                    <th key={h} style={s.th}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {gosterilen.map((a, i) => (
                                <tr key={a.id} style={{ background: i % 2 === 0 ? "white" : "#f9fafb" }}>
                                    <td style={{ ...s.td, fontWeight: "700" }}>{a.sembol}</td>
                                    <td style={s.td}>{a.piyasa}</td>
                                    <td style={s.td}>{a.para_birimi}</td>
                                    <td style={s.td}>{a.fiyat ?? "—"}</td>
                                    <td style={{ ...s.td, fontWeight: "600", color: "#16a34a" }}>{a.hedef_fiyat}</td>
                                    <td style={{ ...s.td, fontWeight: "600",
                                        color: (a.potansiyel || 0) >= 0 ? "#16a34a" : "#dc2626" }}>
                                        {a.potansiyel != null ? `${a.potansiyel > 0 ? "+" : ""}${a.potansiyel}%` : "—"}
                                    </td>
                                    <td style={s.td}>
                                        <div style={{ display: "flex", gap: "4px" }}>
                                            {a.bildirim_mail   && <span style={s.badge}>📧</span>}
                                            {a.bildirim_popup  && <span style={s.badge}>🔔</span>}
                                        </div>
                                    </td>
                                    <td style={{ ...s.td, fontSize: "11px", color: "#6b7280" }}>{tarihFormat(a.created_at)}</td>
                                    <td style={{ ...s.td, fontSize: "11px", color: "#6b7280" }}>{tarihFormat(a.tetiklendi_at)}</td>
                                    <td style={s.td}>
                                        <span style={{ padding: "2px 8px", borderRadius: "99px", fontSize: "11px",
                                            fontWeight: "600",
                                            background: a.aktif ? "#dcfce7" : "#f3f4f6",
                                            color:      a.aktif ? "#16a34a" : "#6b7280" }}>
                                            {a.aktif ? "✅ Aktif" : "⏸ Pasif"}
                                        </span>
                                    </td>
                                    <td style={s.td}>
                                        <div style={{ display: "flex", gap: "4px" }}>
                                            <button onClick={() => setDuzenleItem({ ...a })}
                                                style={s.islemBtn} title="Düzenle">✏️</button>
                                            <button onClick={() => durumDegistir(a.id, !a.aktif)}
                                                style={s.islemBtn} title={a.aktif ? "Pasifleştir" : "Aktifleştir"}>
                                                {a.aktif ? "⏸" : "▶️"}
                                            </button>
                                            <button onClick={() => sil(a.id)}
                                                style={{ ...s.islemBtn, color: "#ef4444" }} title="Sil">🗑️</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Düzenleme Popup */}
            {duzenleItem && (
                <div style={s.overlay}>
                    <div style={s.modal}>
                        <h3 style={{ margin: "0 0 1.25rem", fontSize: "16px", color: "#1e3a5f" }}>
                            ✏️ Alarm Düzenle — {duzenleItem.sembol}
                        </h3>
                        <div style={{ display: "flex", flexDirection: "column", gap: "12px", fontSize: "13px" }}>
                            {[
                                ["Piyasa",       duzenleItem.piyasa],
                                ["Sembol",       duzenleItem.sembol],
                                ["Para Birimi",  duzenleItem.para_birimi],
                                ["Mevcut Fiyat", duzenleItem.fiyat ?? "—"],
                            ].map(([label, val]) => (
                                <div key={label} style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span style={{ color: "#6b7280" }}>{label}:</span>
                                    <strong>{val}</strong>
                                </div>
                            ))}

                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span style={{ color: "#6b7280" }}>Hedef Fiyat:</span>
                                <input type="number"
                                    value={duzenleItem.hedef_fiyat}
                                    onChange={e => setDuzenleItem(p => ({ ...p, hedef_fiyat: e.target.value }))}
                                    style={{ width: "130px", padding: "4px 8px", borderRadius: "6px",
                                        border: "1px solid #d1d5db", fontSize: "13px", textAlign: "right" }} />
                            </div>

                            {duzenleItem.hedef_fiyat && parseFloat(duzenleItem.fiyat) > 0 && (
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span style={{ color: "#6b7280" }}>Potansiyel:</span>
                                    <strong style={{ color: ((parseFloat(duzenleItem.hedef_fiyat) - parseFloat(duzenleItem.fiyat)) / parseFloat(duzenleItem.fiyat) * 100) >= 0 ? "#16a34a" : "#dc2626" }}>
                                        {((parseFloat(duzenleItem.hedef_fiyat) - parseFloat(duzenleItem.fiyat)) / parseFloat(duzenleItem.fiyat) * 100).toFixed(2)}%
                                    </strong>
                                </div>
                            )}

                            <div>
                                <div style={{ color: "#6b7280", marginBottom: "6px" }}>Bildirim Tercihi:</div>
                                <div style={{ display: "flex", gap: "16px" }}>
                                    {[
                                        ["Mail",   "bildirim_mail"],
                                        ["Pop-up", "bildirim_popup"],
                                    ].map(([ad, key]) => (
                                        <label key={ad} style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                                            <input type="checkbox"
                                                checked={duzenleItem[key]}
                                                onChange={e => setDuzenleItem(p => ({ ...p, [key]: e.target.checked }))} />
                                            {ad}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div style={{ display: "flex", gap: "8px", marginTop: "1.5rem", justifyContent: "flex-end" }}>
                            <button onClick={() => setDuzenleItem(null)}
                                style={{ padding: "6px 16px", borderRadius: "8px",
                                    border: "1px solid #d1d5db", background: "white",
                                    cursor: "pointer", fontSize: "13px" }}>
                                Vazgeç
                            </button>
                            <button onClick={kaydet}
                                style={{ padding: "6px 16px", borderRadius: "8px", border: "none",
                                    background: "#1e3a5f", color: "white",
                                    cursor: "pointer", fontSize: "13px" }}>
                                Kaydet
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

const s = {
    sayfa:     { padding: "1.5rem" },
    header:    { display: "flex", justifyContent: "space-between", alignItems: "flex-start",
                 marginBottom: "1.5rem", flexWrap: "wrap", gap: "1rem" },
    baslik:    { margin: 0, fontSize: "20px" },
    altBaslik: { color: "#6b7280", fontSize: "13px", margin: "4px 0 0" },
    filtreBtn: { padding: "5px 14px", borderRadius: "8px", border: "1px solid #e5e7eb",
                 cursor: "pointer", fontSize: "12px", fontWeight: "600" },
    tablo:     { width: "100%", borderCollapse: "collapse", fontSize: "13px", background: "white",
                 boxShadow: "0 1px 4px rgba(0,0,0,0.08)", borderRadius: "8px", overflow: "hidden" },
    thead:     { background: "#1e3a5f" },
    th:        { padding: "0.5rem 0.6rem", color: "white", textAlign: "left",
                 whiteSpace: "nowrap", fontSize: "11px" },
    td:        { padding: "0.4rem 0.6rem", borderBottom: "1px solid #f0f0f0",
                 verticalAlign: "middle", fontSize: "12px" },
    badge:     { fontSize: "14px" },
    islemBtn:  { background: "none", border: "none", cursor: "pointer", fontSize: "14px",
                 padding: "2px 4px", borderRadius: "4px" },
    bos:       { textAlign: "center", padding: "4rem", color: "#9ca3af",
                 background: "white", borderRadius: "12px",
                 boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
    overlay:   { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
                 display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
    modal:     { background: "white", borderRadius: "12px", padding: "1.5rem",
                 width: "380px", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" },
};
